// extracted by mini-css-extract-plugin
export default {"AddToCartButton":"AddToCartButton-styles__AddToCartButton__zJq1X"};